import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// register worker inside public/workers/push-notification-worker.js
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const workerPath = `${window.location.origin}/workers/push-notification-worker.js`;

    navigator.serviceWorker
      .register(workerPath)
      .then((registration) => {
        console.info('Service Worker registered with scope:', registration.scope);
      })
      .catch((err) => {
        console.error('Service Worker registration failed:', err);
      });
  });
}
